import {computed, markRaw, useSlots} from 'vue';
import ModalVideo from '@/components/ZModal/components/Video.vue';
import ModalImage from '@/components/ZModal/components/Image.vue';
import ModalHtml from '@/components/ZModal/components/Html.vue';

export const useComputedValue = (theme, data, currentSlide) => {
    const slots = useSlots()

    const classObject = computed(() => {
        let arrClass = []

        if (theme) {
            arrClass.push(`z-modal--theme-${theme}`)
        }

        if (data && data.length > 1) {
            arrClass.push('z-modal--slider')
        }

        return arrClass
    })

    const currentComponent = computed(() => {
        const components = {
            'modal-video': ModalVideo,
            'modal-image': ModalImage,
            'modal-html': ModalHtml
        }

        if (currentSlide.value && currentSlide.value.type) {
            if (currentSlide.value.type === 'photo') {
                return markRaw(components['modal-image'])
            }
            return markRaw(components[`modal-${currentSlide.value.type}`])
        }

        return false
    })

    const hasSlotData = computed(() => {
        return slots.default !== undefined
    })

    return {classObject, currentComponent, hasSlotData}
}
